export default "__VITE_ASSET__DWkg6hEL__"